<template>
  <a
    :href="href"
    class="widget-link"
    :class="[`widget-link--variant-${variant}`, `widget-link--size-${size}`]"
  >
    <slot />
  </a>
</template>

<script lang="ts" setup>
const {
  href = '#',
  variant = 'primary',
  size = '16',
} = defineProps<{
  href?: string
  variant?: 'primary' | 'secondary'
  size?: '12' | '16'
}>()
</script>

<style lang="scss" scoped>
@import '@/styles/custom-variables.scss';

.widget-link {
  display: inline-block;

  &--size-12 {
    font-size: 12px;
    line-height: 16px;
  }

  &--size-16 {
    font-size: 16px;
    line-height: 20px;
  }

  &--variant-primary {
    color: $blue;
    font-weight: $semi-bold-font;

    &:hover,
    &:active {
      color: $gray8;
    }
  }

  &--variant-secondary {
    color: $gray5;
    font-weight: $regular-font;
    text-decoration: underline;

    &:hover,
    &:active {
      color: $gray6;
    }
  }
}
</style>
